import { render } from "./ProfileAlerts.view.vue?vue&type=template&id=cd14359c"
import script from "./ProfileAlerts.view.vue?vue&type=script&lang=js"
export * from "./ProfileAlerts.view.vue?vue&type=script&lang=js"

import "./ProfileAlerts.view.vue?vue&type=style&index=0&id=cd14359c&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__